import {makeAuthRequest} from '../makeApiRequest'

const apiRequest = makeAuthRequest(true)
const prefix = process.env.REACT_APP_MERGER_SERVICE_API || 'api/merger'

export const getListBasketsMergeSet = () => {
    return apiRequest({
        url: `${prefix}/set-baskets/search`,
        method: 'POST',
        data: {}
    })
}

export const getSetBasketDetail = (basketId) => {
    return apiRequest({
        url: `${prefix}/set-basket/${basketId}/detail`,
        method: 'GET'
    })
}

export const deleteSetBasket = (barcode, data) => {
    return apiRequest({
        url: `${prefix}/set-basket/${barcode}`,
        method: 'DELETE',
        data
    })
}

export const getBasketByItem = (itemNumber) => {
    return apiRequest({
        url: `${prefix}/get-basket-by-item/${itemNumber}`,
        method: 'GET',
    })
}